import { Button } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { useHelpStore } from '@/stores/helpStore';

interface HelpButtonProps {
  topicId?: string; // 特定トピックを開く
  size?: 'small' | 'middle' | 'large';
  position?: 'fixed' | 'inline';
}

/**
 * ヘルプボタンコンポーネント
 *
 * 機能:
 * - クリックでヘルプモーダルを開く
 * - 固定位置表示（右下）またはインライン表示
 * - モバイル対応（ボタンサイズと配置）
 */
export function HelpButton({ topicId, size, position = 'inline' }: HelpButtonProps) {
  const { openModal } = useHelpStore();

  // 固定位置ボタン
  if (position === 'fixed') {
    return (
      <Button
        type="primary"
        shape="circle"
        icon={<QuestionCircleOutlined />}
        size="large"
        onClick={() => openModal(topicId)}
        style={{
          position: 'fixed',
          bottom: '24px',
          right: '24px',
          width: '56px',
          height: '56px',
          fontSize: '24px',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
          zIndex: 1000,
        }}
        aria-label="ヘルプを開く"
      />
    );
  }

  // インラインボタン
  return (
    <Button
      type="text"
      icon={<QuestionCircleOutlined />}
      size={size || 'middle'}
      onClick={() => openModal(topicId)}
      aria-label="ヘルプを開く"
    >
      ヘルプ
    </Button>
  );
}
